import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { User } from '../../models/user';

@Component({
  selector: 'app-disable-user-dialog',
  templateUrl: './disable-user-dialog.component.html',
  styleUrls: ['./disable-user-dialog.component.scss'],
})
export class DisableUserDialogComponent {
  users: User[];
  additionalNote = '';

  constructor(
    public dialogRef: MatDialogRef<DisableUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.users = this.data?.users;
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    this.dialogRef.close(this.additionalNote);
  }
}
